<template>
  <div class="progressing-bar">
    <span class="bar">
      <span class="progress"></span>
    </span>
  </div>
</template>

<script>
import("./style.css");
export default {
  name: "Progress",
  data: () => ({}),
};
</script>
